/**
 * Capability string constants — mirror backend `core/authz.py:Capability`.
 *
 * The backend is the security boundary; these gate UI visibility only (nav,
 * buttons, tabs) from the `capabilities` set returned by `/users/me`.
 */
export const CAPABILITIES = {
  CASES_READ: "cases:read",
  CASES_CREATE: "cases:create",
  PROVIDER_REQUESTS: "provider_requests:use",
  ASSESSMENT_PREP: "assessment_prep:use",
  ASSESSMENT_SCRIBE: "assessment_scribe:use",
  REPORT_BUILDER: "report_builder:use",
  REPORT_QA: "report_qa:use",
  TEMPLATES: "templates:read",
  DOCUMENTS: "documents:use",
  TRANSCRIPTION: "transcription:use",
  INVOICE_STUDIO: "invoice_studio:use",
  BOOKING_APPROVALS: "booking_approvals:manage",
  ADMIN: "admin:manage",
} as const;

export type CapabilityValue = (typeof CAPABILITIES)[keyof typeof CAPABILITIES];
